import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { IReporteBasico } from 'src/app/models/reporte-buscar/reporte-buscar.model';
import { environment } from '../../../environments/environment';
import { BackendAuthService } from './backend-auth.service';
import { SessionService } from './session.service';
import { getHeaders } from '../utils/headersUtils';

export interface ICreateReportParams {
  rut: string;
  organizacion: string;
  idUsuario: string;
  tipoOperacion: string;
}

export interface ISearchReportParams {
  rut: string,
  idOrganizacion: string
}

export interface IDetailsReportParams {
  rut: string;
  idOrganizacion: string;
  idTransaccion: string;
}

export interface IRequestInformeBasico {
  rut: string;
  tipoOperacion: string;
  informeComercial?: IRequestInformeComercial;
  consultaSii?: boolean;
}

export interface IRequestInformeComercial {
  user: string;
  pass: string;
  vendor: string;
}

@Injectable({
  providedIn: 'root'
})
export class ReporteService {
  private endpoint: string = environment.backend.report.url;
  private servicio: string = environment.backend.report.servicio;

  constructor(
    private http: HttpClient,
    private _sessionService: SessionService) { }

  public createReport(rut: string, tipoOperacion: string, vendor: string = 'EQUIFAX_COMERCIAL_PLATINUM') {//, consultaSii?: boolean

    const payload: IRequestInformeBasico = {
      rut,
      tipoOperacion,
      consultaSii: true
    }

    /*if(consultaSii === true || consultaSii === false) {
      payload.consultaSii = consultaSii;
    }*/

    if (tipoOperacion === '11') {
      payload.informeComercial = {
        user: '',
        pass: '',
        vendor: vendor
      }
    }

    const headers = getHeaders(this._sessionService.getOrganization(), this._sessionService.getUserInfo().username, 'WEB');
    
    return this.http.post(`${this.endpoint}basicReportInternal`, payload, { headers: headers });
  }

  public searchReport(searchReportParams: ISearchReportParams) {
    let params = new HttpParams();
    params = params.append("rut", searchReportParams.rut);

    const headers = getHeaders(this._sessionService.getOrganization(), this._sessionService.getUserInfo().username, 'WEB');

    return this.http.get(`${this.endpoint}basicReportSearch`, { params, headers });
  }

  public detailsReport(searchReportParams: IDetailsReportParams) {
    let params = new HttpParams();
    params = params.append("rut", searchReportParams.rut);
    params = params.append("idTransaccion", searchReportParams.idTransaccion);

    const headers = getHeaders(this._sessionService.getOrganization(), this._sessionService.getUserInfo().username, 'WEB');

    return this.http.get(`${this.endpoint}basicReportSearchTX`, { params, headers });
  }

  basicReportLastUpdated(rut: string, tipoOperacion :string): Observable<IReporteBasico> {
    let params = new HttpParams();
    params = params.append("rut", rut);
    params = params.append("tipoOperacion", tipoOperacion);

    const headers = getHeaders(this._sessionService.getOrganization(), this._sessionService.getUserInfo().username, 'WEB');

    return this.http.get<IReporteBasico>(`${this.endpoint}basicReportSearchUpdated`, { params, headers });
  }

}
